// @ts-nocheck
import React, { lazy, Suspense } from "react";

import RouteLoadingIndicator from "../RouteLoadingIndicator/RouteLoadingIndicator";

const LazyComponent = lazy(() => import("./Unsubscribe.component"));

const Unsubscribe = props =>
  <Suspense fallback={<RouteLoadingIndicator />}>
    <LazyComponent {...props} />
  </Suspense>;

export default Unsubscribe;
